import { Device } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_DEVICE } from "@/constants/resultsLimits";
import { isGeotabSystemGroup } from "@/utilities/groupIndex";

const EMPTY = new Set<string>();

/**
 * The groups at least one vehicle of the database is assigned to, archived vehicles included.
 * Geotab's group list also holds user groups, DVIR fields, org units and system groups; the
 * group pickers of the audit offer only these vehicle groups.
 */
export function useVehicleGroupIds() {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const query = useQuery<Pick<Device, "id" | "groups">[]>({
    queryKey: ["auditVehicleGroups", activeSessionId],
    queryFn: ({ signal }) =>
      geotabClient.call(
        "Get",
        { typeName: "Device", propertySelector: { fields: ["id", "groups"], isIncluded: true }, resultsLimit: RESULTS_LIMIT_DEVICE },
        signal,
      ),
  });
  const ids = useMemo(() => {
    if (!query.data) return EMPTY;
    const set = new Set<string>();
    for (const device of query.data) for (const group of device.groups ?? []) if (!isGeotabSystemGroup(group.id)) set.add(group.id);
    return set;
  }, [query.data]);
  return { vehicleGroupIds: ids, isLoading: query.isLoading };
}
